export default __webpack_public_path__ + "static/media/cPrancheta_1.3c9378b4.png";